export default "__VITE_ASSET__BNBg$UlN__"